<template>
	<div class="bg-white py-8 sm:py-16">
		<div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
			<a href="https://github.com/linkarkitektur/SpeckleLCA">
				<div
					class="relative overflow-hidden bg-gray-900 px-6 py-20 shadow-xl sm:rounded-3xl sm:px-10 sm:py-24 md:px-12 lg:px-20"
				>
					<div class="absolute inset-0 bg-gray-900/90 mix-blend-multiply" />
					<div
						class="absolute -left-80 -top-56 transform-gpu blur-3xl"
						aria-hidden="true"
					>
						<div
							class="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#0066CC] to-[#CCE5FF] opacity-[0.45]"
							style="
								clip-path: polygon(
									74.1% 44.1%,
									100% 61.6%,
									97.5% 26.9%,
									85.5% 0.1%,
									80.7% 2%,
									72.5% 32.5%,
									60.2% 62.4%,
									52.4% 68.1%,
									47.5% 58.3%,
									45.2% 34.5%,
									27.5% 76.7%,
									0.1% 64.9%,
									17.9% 100%,
									27.6% 76.8%,
									76.1% 97.7%,
									74.1% 44.1%
								);
							"
						/>
					</div>
					<div
						class="hidden md:absolute md:bottom-16 md:left-[50rem] md:block md:transform-gpu md:blur-3xl"
						aria-hidden="true"
					>
						<div
							class="aspect-[1097/845] w-[68.5625rem] bg-gradient-to-r from-[#009999] to-[#CCFFFF] opacity-25"
							style="
								clip-path: polygon(
									74.1% 44.1%,
									100% 61.6%,
									97.5% 26.9%,
									85.5% 0.1%,
									80.7% 2%,
									72.5% 32.5%,
									60.2% 62.4%,
									52.4% 68.1%,
									47.5% 58.3%,
									45.2% 34.5%,
									27.5% 76.7%,
									0.1% 64.9%,
									17.9% 100%,
									27.6% 76.8%,
									76.1% 97.7%,
									74.1% 44.1%
								);
							"
						/>
					</div>

					<div class="relative mx-auto max-w-2xl lg:mx-0">
						<figure>
							<blockquote
								class="mt-6 text-lg font-normal text-white sm:text-xl sm:leading-8"
							>
								<p>
									Join our efforts to democratise sustainability and LCA
									calculations by contributing towards this project. Everything
									made in this project is open-sourced and will continue to be
									open for all.
								</p>
							</blockquote>
							<figcaption class="mt-6 text-lg text-white">
								<div class="font-medium underline">
									https://github.com/linkarkitektur/SpeckleLCA
								</div>
							</figcaption>
						</figure>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	export default defineComponent({
		name: 'ContributeComponent',
		components: {},
		setup() {}
	})
</script>
